(() => {
  const known = new Map([
    ['standard (no lining)', 'standard'], ['standard', 'standard'], ['only cap', 'standard'], ['cap only', 'standard'],
    ['standard + buttons', 'standard-buttons'], ['add buttons', 'standard-buttons'], ['cap with buttons', 'standard-buttons'],
    ['satin lining', 'satin'], ['satin lined', 'satin'], ['add satin lined', 'satin'],
    ['satin + buttons', 'satin-buttons'], ['satin lined + buttons', 'satin-buttons'], ['add satin lined + buttons', 'satin-buttons'], ['add satin lined and buttons', 'satin-buttons']
  ]);
  function enhance(root) {
    const picker = root.querySelector('.pc-pdp-picker');
    const form = picker?.closest('form');
    if (!picker || !form || picker.dataset.ready) return;
    const select = form.querySelector('select[name="id"]');
    const nativeSwatch = form.querySelector('.t4s-swatch');
    let data;
    try { data = JSON.parse(picker.querySelector('[data-pc-options]').textContent); } catch { return; }
    if (!select || !nativeSwatch || data.optionCount !== 1) return;
    const variants = data.variants.map(v => ({...v, key: known.get(v.title.trim().toLowerCase().replace(/\s+/g, ' '))}));
    if (variants.some(v => !v.key) || new Set(variants.map(v => v.key)).size !== variants.length) return;
    if (variants.some(v => ![...nativeSwatch.querySelectorAll('[data-swatch-item]')].some(el => el.dataset.value === v.title))) return;
    const checkbox = picker.querySelector('[data-pc-buttons]');
    const buttons = [...picker.querySelectorAll('[data-pc-lining]')];
    const getCurrent = () => variants.find(v => String(v.id) === select.value);
    if (!getCurrent()) return;
    const formatDelta = value => new Intl.NumberFormat(document.documentElement.lang || 'en-US', {style:'currency',currency:data.currency}).format(value / 100);
    let updating = false;
    function sync() {
      const current = getCurrent();
      if (!current) { picker.hidden = true; form.classList.remove('pc-pdp-enhanced'); return; }
      const satin = current.key.startsWith('satin');
      const hasButtons = current.key.endsWith('-buttons');
      checkbox.checked = hasButtons;
      buttons.forEach(button => {
        const target = variants.find(v => v.key === button.dataset.pcLining + (hasButtons ? '-buttons' : ''));
        button.setAttribute('aria-pressed', String(button.dataset.pcLining === (satin ? 'satin' : 'standard')));
        button.disabled = !target || (!target.available && target.id !== current.id);
        button.querySelector('.pc-pdp-option-price').textContent = !target ? data.text.unavailable : target.money + (target.available ? '' : ' · ' + data.text.soldOut);
      });
      const plain = variants.find(v => v.key === (satin ? 'satin' : 'standard'));
      const withButtons = variants.find(v => v.key === (satin ? 'satin-buttons' : 'standard-buttons'));
      const alternative = hasButtons ? plain : withButtons;
      checkbox.disabled = !alternative || !alternative.available;
      picker.querySelector('[data-pc-button-price]').textContent = plain && withButtons ? (withButtons.price >= plain.price ? '+' : '−') + formatDelta(Math.abs(withButtons.price-plain.price)) : data.text.unavailable;
      picker.querySelector('.pc-pdp-lining-note').textContent = satin ? data.text.satinNote : data.text.standardNote;
      picker.querySelector('.pc-pdp-selected').textContent = data.text.selected + ' ' + current.title + ' · ' + current.money + (current.available ? '' : ' · ' + data.text.soldOut);
      picker.hidden = false;
      form.classList.add('pc-pdp-enhanced');
    }
    function choose(key) {
      const variant = variants.find(v => v.key === key);
      if (!variant?.available) { sync(); return; }
      const swatch = [...nativeSwatch.querySelectorAll('[data-swatch-item]')].find(el => el.dataset.value === variant.title);
      if (!swatch) return;
      updating = true;
      swatch.click();
      updating = false;
      requestAnimationFrame(sync);
    }
    buttons.forEach(button => button.addEventListener('click', () => choose(button.dataset.pcLining + (checkbox.checked ? '-buttons' : ''))));
    checkbox.addEventListener('change', () => choose((getCurrent()?.key.startsWith('satin') ? 'satin' : 'standard') + (checkbox.checked ? '-buttons' : '')));
    form.addEventListener('change', () => requestAnimationFrame(sync));
    nativeSwatch.addEventListener('click', () => { if (!updating) requestAnimationFrame(sync); });
    const observer = new MutationObserver(() => requestAnimationFrame(sync));
    observer.observe(nativeSwatch, {subtree:true, attributes:true, attributeFilter:['class']});
    window.addEventListener('popstate', () => requestAnimationFrame(sync));
    picker.dataset.ready = 'true';
    sync();
  }
  const init = () => document.querySelectorAll('.pc-product-refresh').forEach(enhance);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true}); else init();
  document.addEventListener('shopify:section:load', init);
})();
